export default "__VITE_ASSET__6IlR7Azm__"